import 'whatwg-fetch';

export default (url, data) => fetch(
  url,
  {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json;charset=UTF-8' }),
    body: JSON.stringify(data),
    credentials: 'same-origin'
  }
).then(response => response.json());



// WEBPACK FOOTER //
// ./src/actions/fetchservice.js